import _cloneDeep from "lodash/cloneDeep";
/**
 * Transform metric filters at query execution time, converting display units
 * to storage values.
 */
import { processMetricFiltersForQuery } from 'app/views/boards/panels/ude/filters/metricFilterUtils';
/**
 * Recursively process metric filter groups, converting display units to storage values.
 * Handles nested filterGroups so all levels get converted.
 */
function processMetricFilterGroup(filterGroup, measurement, measurements) {
  if (filterGroup.filters?.length) {
    filterGroup.filters = processMetricFiltersForQuery(filterGroup.filters, measurement, measurements);
  }
  if (filterGroup.filterGroups?.length) {
    for (const nestedGroup of filterGroup.filterGroups) {
      processMetricFilterGroup(nestedGroup, measurement, measurements);
    }
  }
}

/**
 * Transform metric filters in a query, converting display units to storage values.
 *
 * @param query The original query
 * @param measurements Optional measurement definitions for metric filter unit conversion
 * @returns A new query with transformed filters (original is not mutated)
 */
export async function transformQueryFilters(query, measurements) {
  const hasMetricFilters = !!query.filters?.metrics?.filterGroups?.length;
  if (!hasMetricFilters) {
    return query;
  }

  // Deep clone the query to avoid mutating the original
  const transformedQuery = _cloneDeep(query);

  // Process metric filters: convert display units to storage values
  const metricFilterGroups = transformedQuery.filters?.metrics?.filterGroups;
  if (metricFilterGroups) {
    for (const filterGroup of metricFilterGroups) {
      processMetricFilterGroup(filterGroup, transformedQuery.measurement, measurements);
    }
  }
  return transformedQuery;
}